module.exports = __webpack_public_path__ + "4f650c792f1553d0ad0da698f31e24db.pdf";